import { render, staticRenderFns } from "./SubOrdersSelected.vue?vue&type=template&id=acd8bac8&scoped=true&"
import script from "./SubOrdersSelected.vue?vue&type=script&lang=js&"
export * from "./SubOrdersSelected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acd8bac8",
  null
  
)

export default component.exports